import React from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  CaretIcon,
  RepeatIcon,
} from "../../../../../shared/infrastructure";
import { OfferT, OfferViewT } from "../../../domain";

type OfferCardActionButtonsProps = {
  offer: OfferT;
  view: OfferViewT;
  tableViewIsOpen?: boolean;
  toggleTable?: () => void;
  toggleView?: () => void;
  toggleDetails?: () => void;
  showDetails?: boolean;
};

export const OfferCardActionButtons = ({
  offer,
  view,
  tableViewIsOpen,
  toggleTable,
  toggleView,
}: OfferCardActionButtonsProps): React.ReactElement => {
  const [t] = useTranslation("global");

  return offer.type === "single" ? (
    <section className="grid h-full w-full grid-cols-2">
      {view === "rep" ? (
        <Button
          className="mx-1 h-full  w-full md:tracking-tighter"
          appearance="secondary"
          endIcon={
            <CaretIcon
              fill="#919191"
              className={tableViewIsOpen ? "rotate-180" : ""}
            />
          }
          onClick={toggleTable}
        >
          {tableViewIsOpen
            ? t<string>(
                "context.private.components.offer-card-details.buttons.show-less"
              )
            : t<string>(
                "context.private.components.offer-card-details.buttons.show-more"
              )}
        </Button>
      ) : (
        <section />
      )}

      <Button
        className="mx-2 h-full w-full"
        endIcon={<RepeatIcon fill="white" />}
        onClick={toggleView}
      >
        {view === "offer"
          ? t<string>(
              "context.private.components.offer-card-details.buttons.rep-view"
            )
          : t<string>(
              "context.private.components.offer-card-details.buttons.offer-view"
            )}
      </Button>
    </section>
  ) : (
    <div />
  );
};
